module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "buckets"
  }, [_c('ul', {
    staticClass: "bucket-list clearfix"
  }, _vm._l((_vm.separatedArray), function(singleWord, index) {
    return _c('li', {
      key: index,
      staticClass: "shadowBox"
    }, [_c('span', [_vm._v("\n                                    " + _vm._s(singleWord) + "\n                                    "), _c('i', {
      staticClass: "fa fa-remove design-d design-delete",
      on: {
        "click": function($event) {
          return _vm.deleteSingleWordSingle(singleWord)
        }
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywordsData),
      expression: "keywordsData"
    }],
    staticStyle: {
      "border": "1px solid black",
      "padding": "10px"
    },
    attrs: {
      "placeholder": "Enter keywords",
      "rows": "4",
      "cols": "150"
    },
    domProps: {
      "value": (_vm.keywordsData)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywordsData = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addData
    }
  }, [_vm._v("Submit")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Blocked Keywords")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Please add domain specific keywords entries here")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f9a05668!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/KeywordBlock.vue
// module id = 725
// module chunks = 2